import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { QSpinner, QText } from '@qualio/ui-components';
import { ProbabilityType } from '../../../types/eventMetadata';
import { EMPTY_FILTER_VALUE } from '../../../types/qualityEvent';

const ActiveProbabilityFilter = ({
  value,
  probabilitiesMap,
}: {
  value: unknown;
  probabilitiesMap: Record<string, ProbabilityType>;
}): ReactElement => {
  const { t } = useTranslation();
  if (value === EMPTY_FILTER_VALUE) {
    return <QText as="span">{t('common.labels.emptyProbabilities')}</QText>;
  }
  const id = value as number;
  const probability = probabilitiesMap[id];
  if (probability) {
    return <QText as="span">{probability.name}</QText>;
  }
  return <QSpinner size="sm" />;
};

export default ActiveProbabilityFilter;
